module.exports = __webpack_public_path__ + "img/note.b80a3c79.svg";